import { SearchQueryOrder, SearchQueryOrderDirection } from "types/generated";

import { PersonalApiKey } from "../gql";
import { PERSONAL_API_KEYS_SORT_CONFIG } from "./constants";

export const sortPersonalApiKeys = (items: PersonalApiKey[], orderBy: SearchQueryOrder) => {
  const sortField = Object.values(PERSONAL_API_KEYS_SORT_CONFIG).find(
    (field) => field === orderBy.field
  );

  if (!sortField) {
    return items;
  }

  const isAscending = orderBy.direction === SearchQueryOrderDirection.Asc;

  return [...items].sort((a, b) => {
    const valueA = String(a[sortField] ?? "");
    const valueB = String(b[sortField] ?? "");

    return isAscending
      ? valueA.localeCompare(valueB, undefined, { numeric: true })
      : valueB.localeCompare(valueA, undefined, { numeric: true });
  });
};
